import { render } from "./table.vue?vue&type=template&id=1514b390&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=1514b390&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1514b390"

export default script